import React from "react"
import { useCart } from "react-use-cart"
import DownArrow from "../../assets/down-arrow.svg"

const ShoppingCart = ({ items, no_of_items, amount }) => {
  const subTotal = items.reduce(
    (acc, currentValue) =>
      acc + currentValue.sales_price * currentValue.quantity,
    0
  )

  console.log(items)

  const { cartTotal } = useCart()

  return (
    <>
      <div className="bg-gray-100 py-10 rounded px-5">
        <div className="mobiles:hidden cart__header pb-8 flex justify-between border-b border-gray-400">
          <p>Shopping Cart</p>
          <p className="cart__items-no">{no_of_items}</p>
        </div>

        <div className="mobiles:hidden cart__items py-5">
          {items.map(({ images, name, sales_price, quantity, itemTotal }) => {
            return (
              <div className="item flex my-5 justify-betweeen">
                <img className="w-1/4" src={images[0]} alt="" />
                <div className="item_info text-xs font-extralight px-3">
                  <p>{name}</p>
                  <p>Quantity: {quantity} </p>
                  <p className="mt-3">
                    ₦{parseInt(sales_price).toLocaleString("en-NG")}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
        <div className="mobiles:hidden cart__voucher-section flex justify-between text-xs border-b py-5 border-t border-gray-400">
          <p>Have a Voucher?</p>
          <img src={DownArrow} alt="down arrow toggle" />
        </div>
        <div className="mobiles:block cart__subtotal-section text-gray-500 text-xs py-5 border-b border-gray-400">
          <div className="flex justify-between py-3">
            <p>Subtotal: </p>
            <p>
              ₦{" "}
              {amount
                ? parseInt(amount).toLocaleString("en-NG")
                : cartTotal.toLocaleString("en-NG")}
            </p>
          </div>
          <div className="flex justify-between py-3">
            <p>Shipping</p>
            <p>Free</p>
          </div>
        </div>
        <div className="cart__total-section">
          <div className="flex justify-between font-semibold py-3 text-black text-xs">
            <p>Total</p>
            <p>
              ₦{" "}
              {amount
                ? parseInt(amount).toLocaleString("en-NG")
                : subTotal.toLocaleString("en-NG")}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default ShoppingCart
